import { Injectable } from '@angular/core';
import { HttpCustomService } from 'app/services/http-custom.service';

@Injectable()
export class ProjectManagementService {
    errorMessage = '';
    data = [];
    projectBaseUrl = 'projects/';

    constructor(
        private customHttpService: HttpCustomService,
    ) { }

    get_projects(callback, project_filter = null) {
        let path = this.projectBaseUrl;

        if (project_filter) {
            path += '?project_type=' + project_filter;
        }

        this.customHttpService.fetchData(path, callback);
    }

    get_project_details(project_id, callback) {
        const path = this.projectBaseUrl + project_id + '/details/';
        this.customHttpService.fetchData(path, callback);
    }

    create_project(project_data, callback) {
        const path = this.projectBaseUrl ;
        this.customHttpService.postData(project_data, path, callback);
    }

    edit_project(
        project_data,
        project_id,
        callback
    ) {
        const path = this.projectBaseUrl + project_id + '/details/';
        this.customHttpService.postData(project_data, path, callback);
    }

    wall_post(
        project_id,
        wall_data,
        callback,
        wall_post_id=null,
        wall_reply_id=null, // This field is optional. If sent then nested reply will happen.

    ) {
        let path = this.projectBaseUrl + project_id + "/wall/";

        if(wall_post_id) {
            path += wall_post_id + "/"
        }

        if(wall_reply_id) {
            wall_data["parent_reply"] = wall_reply_id
        }

        this.customHttpService.postData(wall_data, path, callback, true);
    }

    delete_project(
        project_id,
        callback
    ) {
        const path = this.projectBaseUrl + project_id + "/details/";
        this.customHttpService.deleteData(path, callback);
    }

    wall_get(
        project_id,
        limit,
        offset,
        callback,
        wall_post_id=null,
        single_post=false,
    ) {
        let path;

        if(wall_post_id) {
            if (single_post) {
                path = this.projectBaseUrl + project_id + "/wall/?id=" + wall_post_id;
            } else {
                path = this.projectBaseUrl + project_id + "/wall/" + wall_post_id + "/";
            }
        } else {
            path = this.projectBaseUrl + project_id + "/wall/" + "?limit=" + limit + "&offset=" + offset;
        }

        this.customHttpService.fetchData(path, callback);

    }

    activity_get(
        limit,
        offset,
        callback,
        forAllProject,
        fip_id
    ) {
        // for one project activity
        let path = this.projectBaseUrl + fip_id +"/activity/" + "?limit=" + limit + "&offset=" + offset;

        if(forAllProject) {
            path = this.projectBaseUrl + "activity/" + "?limit=" + limit + "&offset=" + offset;
        }

        return this.customHttpService.fetchData(path, callback);

    }

    download_file(
        project_id,
        file_id,
        full_file_name,
        callback
    ) {
        const path = this.projectBaseUrl + project_id + "/files/" + file_id + "/";
        this.customHttpService.fetchData(path, callback, true);
    }

    files_get(
        project_id,
        limit,
        offset,
        callback
    ) {

        if (limit < 10) {
            limit = 10;
        }

        const path = this.projectBaseUrl + project_id + "/files/" + "?limit=" + limit + "&offset=" + offset;

        this.customHttpService.fetchData(path, callback);
    }

    export_project(
        callback
    ) {
        const path = this.projectBaseUrl + "export/";

        this.customHttpService.fetchData(path, callback, true)
    }

    getEvaluation(
        project_id,
        callback
    ) {

        const path = this.projectBaseUrl + project_id + '/evaluation/';

        this.customHttpService.fetchData(path, callback);

    }
    postEvaluation(
        evaluationData,
        project_id,
        callback
    ) {

        const path = this.projectBaseUrl + project_id + '/evaluation/';

        this.customHttpService.postData(evaluationData, path, callback);

    }

    deleteFile(fileId, projectId, callBack) {
        const path = this.projectBaseUrl + projectId + '/files/' + fileId + '/';
        this.customHttpService.deleteData(path, callBack)
    }

    deleteWallPost(wallId, parentId, isParent, projectId, callBack) {
        let path = this.projectBaseUrl + projectId + '/wall/' + wallId + '/';
        if (!isParent) {
            path = this.projectBaseUrl + projectId + '/wall/' + parentId + '/reply/' + wallId + '/';
        }
        this.customHttpService.deleteData(path, callBack);
    }
}
